(function(){
	'use strict';
	angular
	.module('app')
	.controller('ClientesController', ClientesController)
	.filter('trustAs', function ($sce) {
		return function (input, type) {
			if (typeof input === "string") {
				return $sce.trustAs(type || 'html', input);
			}
			return "";
		};
	});
	function ClientesController(API,$sce, $timeout, $state, $scope, $location, $rootScope, brCidadesEstados){
		let vm = this;
		vm.date = '';

		vm.$onInit = () => {
			getFromAPI();
		}

		String.prototype.stripHTML = function() {return this.replace(/<.*?>/g, '');}
		
		function getFromAPI() {
			API.get('/parceiros').then(result => {
				vm.clientes = groupBy(result.data, 'descricao_parceiro').sort((a,b)=> (a.descricao_parceiro > b.descricao_parceiro) ? 1 : ((b.descricao_parceiro > a.descricao_parceiro) ? -1 : 0))
			});
		}

		function groupBy(data, key) {
			var grouped = []; 
			data.forEach(item => {
				if(!(grouped.map(x => x[key].toUpperCase())).includes(item[key].toUpperCase())){
					grouped.push(item['imagem_parceiro'] ? {descricao_parceiro: item[key].stripHTML(), imagem_parceiro: item['imagem_parceiro']} : {descricao_parceiro: item[key].stripHTML()})

				}
			})	
			return grouped;
		}
  	}//fim controller
  })();